export default "__VITE_ASSET__B2A3VE3V__"